// extracted by mini-css-extract-plugin
export default {"center":"Login_center__q78ap"};